import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { DrillTopic } from "./Drill";

// Название темы: по ней собраны ошибки разбора и задачи тренировки.
export const TOPIC_LABELS: Record<DrillTopic, MessageDescriptor> = {
  build: msg({ id: "drills.topic.build", message: "Build" }),
  anti_heal: msg({ id: "drills.topic.anti_heal", message: "Anti-heal" }),
  defense: msg({ id: "drills.topic.defense", message: "Defense" }),
  killer: msg({ id: "drills.topic.killer", message: "Your main killer" }),
  escapes: msg({ id: "drills.topic.escapes", message: "Enemies who got away" }),
  farm: msg({ id: "drills.topic.farm", message: "Farm" }),
};
